// ======================================================================
// File: src/modules/ppe/pages/procurement/purchase-return/list/PurchaseReturnFilterBar.jsx
// Module: PPE → Procurement → Purchase Return
//
// Purpose:
// - Filter bar UI for Purchase Return list page
// - Follows same structure as GRNFilterBar.jsx
// - Allows filtering by status, date range and search text
// ======================================================================

import React from "react";

const PURCHASE_RETURN_STATUS = [
  "DRAFT",
  "PENDING_APPROVAL",
  "APPROVED",
  "POSTED",
  "CANCELLED",
];

export default function PurchaseReturnFilterBar({
  filters,
  onChange,
  onSearch,
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: 12,
        alignItems: "center",
        marginBottom: 16,
      }}
    >

      {/* SEARCH */}
      <input
        className="form-control"
        style={{ maxWidth: 260 }}
        placeholder="Search Return No / GRN No / PO No"
        value={filters.search}
        onChange={(e) =>
          onChange({
            ...filters,
            search: e.target.value,
          })
        }
      />

      {/* STATUS */}
      <select
        className="form-select"
        style={{ maxWidth: 180 }}
        value={filters.status}
        onChange={(e) =>
          onChange({
            ...filters,
            status: e.target.value,
          })
        }
      >
        <option value="">All Status</option>

        {PURCHASE_RETURN_STATUS.map((status) => (
          <option key={status} value={status}>
            {status}
          </option>
        ))}
      </select>

      {/* FROM DATE */}
      <input
        type="date"
        className="form-control"
        style={{ maxWidth: 160 }}
        value={filters.from_date}
        onChange={(e) =>
          onChange({
            ...filters,
            from_date: e.target.value,
          })
        }
      />

      {/* TO DATE */}
      <input
        type="date"
        className="form-control"
        style={{ maxWidth: 160 }}
        value={filters.to_date}
        onChange={(e) =>
          onChange({
            ...filters,
            to_date: e.target.value,
          })
        }
      />

      {/* SEARCH BUTTON */}
      <button
        className="btn btn-primary"
        onClick={onSearch}
      >
        Search
      </button>

    </div>
  );
}